import FormLoss from '../../components/FormLoss'
import { Typography } from '@mui/material'
import * as S from './Loss.styles'
import TableLoss from '../../components/TableLoss'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { actions } from '../../LossState'

const Loss = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(actions.clearState())
  }, [dispatch])

  return (
    <S.Wrapper>
      <Typography variant='h5' fontWeight='bold'> Registrar Avarias </Typography>
      <FormLoss />
      <TableLoss />
    </S.Wrapper>
  )
}

export default Loss
